var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReviewStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 22.555,
    height: 21.502,
    fill: "#957027"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-img-review-star"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img-review-star",
    clipPath: "url(#clip-img-review-star)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,8.2A.732.732,0,0,1,.711,7.75c1.1-.08,2.207-.189,3.31-.284S6.2,7.28,7.287,7.186a3.079,3.079,0,0,1,.394-.035c.151.007.212-.06.267-.192q1.2-2.845,2.4-5.685c.117-.277.238-.551.35-.83A.592.592,0,0,1,11.285,0a.6.6,0,0,1,.567.44Q13.212,3.67,14.574,6.9a.348.348,0,0,0,.337.262c1.163.088,2.324.193,3.485.293q1.8.155,3.594.312a.567.567,0,0,1,.536.419.583.583,0,0,1-.216.646q-1.632,1.411-3.262,2.825c-.7.61-1.406,1.224-2.116,1.828a.3.3,0,0,0-.1.338q.8,3.431,1.6,6.864a.61.61,0,0,1-.2.709.619.619,0,0,1-.738-.028q-3-1.817-6-3.63a.334.334,0,0,0-.407,0q-2.989,1.814-5.987,3.611a.953.953,0,0,1-.339.144.577.577,0,0,1-.639-.758c.1-.457.214-.912.32-1.368.431-1.854.86-3.707,1.3-5.559a.306.306,0,0,0-.136-.347Q2.945,11.17.3,8.873A2.844,2.844,0,0,1,0,8.5V8.2",
    transform: "translate(0 -0.001)",
    fill: "#957027"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReviewStar);
export default __webpack_public_path__ + "static/media/icon-review-star.a90de6c67b162552e7dcdd7368b5932b.svg";
export { ForwardRef as ReactComponent };